import React, { useState } from "react";
import "./SQLiSimulator.css"; // Reuse same styles

function NoSQLiSimulator() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [response, setResponse] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        "https://YOUR_API_GATEWAY_URL/dev/nosql-injection", // change to your NoSQL Lambda endpoint
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: username.trim(),
            password: password.trim(),
          }),
        }
      );

      const text = await res.text();
      setResponse(text);
    } catch (err) {
      setResponse(`Error: ${err.message}`);
    }
  };

  return (
    <div className="sqli-container">
      <h1>🔥 NoSQL Injection Simulator</h1>
      

      <form className="sqli-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="text" // keep type text to allow symbols easily
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>

      <div className="sqli-response">{response}</div>
    </div>
  );
}

export default NoSQLiSimulator;
